import apiUrl from '../../assets/apiUrl';
import generateThumbnail from '../../assets/generateThumbnail';
import file from '../../common/file';
import folder from '../../common/folder';
import { getAccessToken } from '../Auth';
import FormData from 'form-data';

interface signedFile extends file {
    signed_token: string;
}

const getSignedUrl = async (url: string) => {
    const options = {
        headers: { 'x-access-token': await getAccessToken() },
    };
    const file: signedFile = await (await fetch(url, options)).json();
    return `${apiUrl}/file/${file.signed_token}`;
};

const getThumbnail = async (folders: folder[], files: file[], file: file) => {
    const foundFolder = folders.find(
        (e) => e.title === '.thumbnails' && e.parent_folder === null
    );
    if (!foundFolder) return undefined;
    const foundFile = files.find(
        (e) =>
            e.filename === file.file_uid &&
            e.folder_uid === foundFolder.folder_uid
    );
    if (foundFile) return foundFile;

    const thumbnail = await generateThumbnail(
        file,
        await getSignedUrl(`${apiUrl}/file?file_uid=${file.file_uid}`)
    );
    if (!thumbnail) return undefined;

    const formData: any = new FormData();
    formData.append('file', thumbnail, file.file_uid);
    const token = await getAccessToken();
    const response = await fetch(
        `${apiUrl}/file?folder_uid=${foundFolder.folder_uid}`,
        {
            body: formData,
            method: 'POST',
            headers: {
                'x-access-token': token,
            },
        }
    );
    const fileRes = await response.json();
    if (fileRes) return fileRes;

    return undefined;
};

const FilesMethods = {
    getSignedUrl,
    getThumbnail,
};

export default FilesMethods;
